<template>
	<div class="ms-talk-message-text">
		
	</div>
</template>
<script>
export default {
	name: 'MSTalkMessageText',
};
</script>
<style>
.ms-talk-message-text {
	
}
</style>
